var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{key:_vm.iframeKey,ref:"iframe",staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"srcdoc":_vm.iframeContent},on:{"load":function($event){return _vm.resizeIframe($event.target)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }